<script type="text/ecmascript-6">
    import DesignerQuestionSelectDoor from "../DesignerQuestionSelectDoor.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectDoor,
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Choose Your Door Design';
                }
            }
        }
    }
</script>
